import ContactCard from './contact-card';

export * from './contact-card';

export default ContactCard;
